import { getRetailSpecificationPage } from './index';
import { createSelector } from '@ngrx/store';

export const getGroupingState = createSelector(
  getRetailSpecificationPage,
  state => state.groupingState,
);

export const getGroupingLoadsLength = createSelector(
  getRetailSpecificationPage,
  state => state.groupingState.loads.length,
);

export const getValidateResponse = createSelector(
  getGroupingState,
  state => state.validateResponse,
);
